import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  MenuItem,
  styled,
} from "@material-ui/core";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import useApi from "../hooks/api";
import { Textfield } from "./ui/form_fields";

const StyledFab = styled(Fab)({
  bottom: "1rem",
  position: "fixed",
  right: "1rem",
});

const typeOptions = [
  "Precatório faltando",
  "Dado incorreto",
  "Sugestão de nova funcionalidade",
];

const initialValues = { type: "", content: "" };

const ContactButton = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { post } = useApi();

  const closeModal = () => setModalOpen(false);

  const handleSubmit = async (contact) => {
    try {
      await post("v1/contact", { contact });

      alert(
        "Email enviado com sucesso. Obrigado por entrar em contato conosco."
      );

      closeModal();
    } catch {
      alert("Falha ao enviar email. Tente novamente mais tarde.");
    }
  };

  return (
    <>
      <Dialog open={modalOpen} onClose={closeModal} fullWidth>
        <DialogTitle>Entre em contato com a gente</DialogTitle>

        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {({ isSubmitting, dirty }) => (
            <Form>
              <DialogContent>
                <Field
                  id="get_in_touch_type_select"
                  name="type"
                  label="Assunto"
                  component={Textfield}
                  isRequired
                  fullWidth
                  select
                >
                  {typeOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Field>

                <div className="pt-20">
                  <Field
                    name="content"
                    label="Descrição"
                    component={Textfield}
                    isRequired
                    fullWidth
                    multiline
                  />
                </div>
              </DialogContent>

              <DialogActions>
                <Button onClick={closeModal} disabled={isSubmitting}>
                  Cancelar
                </Button>

                <Button
                  type="submit"
                  color="primary"
                  disabled={isSubmitting || !dirty}
                >
                  Enviar
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>

      <StyledFab
        id="get_in_touch_button"
        color="primary"
        onClick={() => setModalOpen(true)}
      >
        <ChatBubbleIcon />
      </StyledFab>
    </>
  );
};

export default ContactButton;
